export const getRequester = (users?: IUser[]): IUser | undefined => {
  if (!Array.isArray(users)) return
  return users.find((user) => user.role === "requester")
}

export const getFacilitator = (users?: IUser[]): IUser | undefined => {
  if (!Array.isArray(users)) return
  return users.find((user) => user.role === "facilitator")
}

export const getParticipants = (users?: IUser[]): IUser[] => {
  if (!Array.isArray(users)) return []
  return users.filter((user) => user.role === "participant")
}

export const isFacilitator = (users: IUser[], userEmail: string): boolean | undefined => {
  if (!users || users.length === 0) return false

  const userFacilitator = getFacilitator(users)
  if (userFacilitator === undefined) return false

  if (userFacilitator.email === userEmail) return true
}

export const userRole = (feedback: IFeedback) => {
  const sessionData = JSON.parse(localStorage.getItem("sessionData") ?? "{}")
  const userId = sessionData.id ?? null

  if (!feedback || !feedback.users) return null

  return feedback.users.find((user: IUser) => user.cognito_id === userId)?.role ?? null
}

export const getUserByCognitoId = (cognitoId: string, users?: IUser[]): IUser | undefined => {
  if (!Array.isArray(users)) return
  return users.find((user) => user.cognito_id === cognitoId)
}

export const filterFeedbacksNotRejected = (feedbacks: IFeedback[], userId: string): IFeedback[] => {
  if (!Array.isArray(feedbacks)) return []

  return feedbacks.filter(feedback => {
    const currentUser = getUserByCognitoId(userId, feedback.users)
    return currentUser && currentUser.invitation_status !== 'rejected'
  })
}

export const filterPendingInvitations = (feedbacks: IFeedback[], userId: string): IFeedback[] => {
  if (!Array.isArray(feedbacks)) return []

  return feedbacks.filter(feedback => {
    const currentUser = getUserByCognitoId(userId, feedback.users)
    return currentUser &&
           (currentUser.confirmed_at === null || currentUser.confirmed_at === undefined) &&
           (currentUser.invitation_status === undefined || currentUser.invitation_status !== 'rejected')
  })
}
